import React from 'react';

import { Eye, Pencil } from 'lucide-react';
import { DefaultPopover, Button, DefaultTooltip, DefaultTable } from 'twyne-new.ui';

import TextTruncated from 'components/TextTruncated';
import DeleteIconConfirmation from 'components/table/DeleteIconConfirmation';

export default function AttributesTable({ data, handleEditAttribute, handleDeleteAttribute }) {
  const columns = [{
    dataField: 'key',
    text: 'Key',
  }, {
    dataField: 'label',
    text: 'Label',
  }, {
    dataField: 'type',
    text: 'Type',
  }, {
    dataField: 'defaultValue',
    formatter: formatValue,
    text: 'Default',
  }, {
    text: "",
    dataField: "action",
    formatter: (_, row) => actionsFormatter({ row, onEdit: handleEditAttribute, onDelete: handleDeleteAttribute }),
    className: "w-8",
  }]

  return <DefaultTable
    keyField="key"
    data={data || []}
    columns={columns}
    bordered={false}
  />
}

const actionsFormatter = ({ row, onEdit, onDelete }) => {
  const id = row.key.replace(" ", "_")

  return <div className='flex gap-2 border-l twy-border-base-accent pl-2'>
    <DefaultTooltip content='Edit'>
      <a onClick={() => onEdit(row.key, true)}>
        <Pencil size={16} />
      </a>
    </DefaultTooltip>
    <DefaultTooltip content='Delete'>
      <DeleteIconConfirmation id={`delete-${id}`} handleClick={() => onDelete(row.key)} />
    </DefaultTooltip>
  </div>
}

const formatValue = (cell, row) => {
  const id = `defval-preview-${row.key}`

  if (cell) {
    if (row.type === 'image') {
      return <DefaultPopover
        trigger={<Button variant='ghost' size='sm' color='accent' className='p-0'> <Eye size={16} /> </Button>}
        contentProps={{ side: 'bottom' }}
      >
        <img src={cell.src} alt="feature_image" width="100%" />
      </DefaultPopover>
    }

    if (row.type === 'color') {
      return <div style={{ width: '40px', height: '20px', borderRadius: '2px', background: cell }} />
    }

    if (cell.length > 50) {
      return <TextTruncated maxLength={70} id={id}>
        {cell}
      </TextTruncated>
    }
  }
  return cell
}
